import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <Section className="bg-cream" data-id="element-111" data-mp="1o5zqy212ub4m">
      <div className="rounded-3xl border-2 border-dashed border-teal-300 bg-white p-6 text-center sm:p-8" data-id="element-112" data-mp="223oddeaslqbs">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-teal-50" data-id="element-113" data-mp="1x5d4p6w8hlv5">
          <ShieldCheckIcon className="h-9 w-9 text-teal-600" aria-hidden="true" data-id="element-114" data-mp="19fsi8e0vg6h4" />
        </span>
        <h2 className="mt-4 font-display text-[24px] font-black leading-tight text-navy sm:text-3xl" data-id="element-115" data-mp="14gpecwwmo6aq">
          Your investment is 100% protected
        </h2>
        <p className="mt-3 text-[14.5px] leading-relaxed text-navy/70 sm:text-base" data-id="element-116" data-mp="1edu1p027m7t4">
          Try the GLP-1 Clinical Pathway™ for 7 days. If you feel it doesn’t improve your clinical
          confidence, save you time in consultation, or deliver what we promise — we’ll refund you.
          No questions asked.
        </p>
        <p className="mt-3 text-[13px] font-extrabold uppercase tracking-[0.18em] text-teal-700" data-id="element-117" data-mp="p01edzh2un61">
          Simple · Fast · Risk-free
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-md" data-id="element-118" data-mp="twi7l834vrpz">
        <CTAButton label="Try it risk-free for 7 days" sublabel="Full refund, no questions asked" data-id="element-119" data-mp="yp2wbv76nemn" />
      </div>
    </Section>;
}